import React from 'react';

function ApprovalActionModal({
  open,
  ticket,
  action,
  justification,
  onChange,
  onClose,
  onSubmit,
  loading,
}) {
  if (!open || !ticket) {
    return null;
  }

  const title =
    action === 'approve'
      ? `Approve Ticket #${ticket.ticket_number}`
      : `Reject Ticket #${ticket.ticket_number}`;

  return (
    <div className="approval-modal-overlay">
      <div className="approval-modal">
        <div className="approval-modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="approval-modal-body">
          <p>
            Please provide a justification. This will be stored with the approval
            timeline.
          </p>
          <textarea
            value={justification}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Type your justification here..."
            rows={4}
          />
        </div>
        <div className="approval-modal-footer">
          <button className="btn-secondary" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className={action === 'approve' ? 'btn-primary' : 'btn-danger'}
            onClick={onSubmit}
            disabled={loading || !justification.trim().length}
          >
            {loading ? 'Processing...' : action === 'approve' ? 'Approve' : 'Reject'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ApprovalActionModal;

